import api from "../../utils/Api";
import {
  DELETE_NOTES_REQUEST,
  DELETE_NOTES_SUCCESS,
  DELETE_NOTES_ERROR,
} from "./DeleteNotesTypes";

export const deleteNotesRequest = () => {
  return {
    type: DELETE_NOTES_REQUEST,
  };
};

export const deleteNotesSuccess = (notes) => {
  return {
    type: DELETE_NOTES_SUCCESS,
    payload: notes,
  };
};

export const deleteNotesFailure = (error) => {
  return {
    type: DELETE_NOTES_ERROR,
    payload: error,
  };
};

export const deleteNotes = (notesId) => {
  return async (dispatch) => {
    dispatch(deleteNotesRequest());
    try {
        const response = await api.delete("dashboard/notes/",  {
            headers: {
              Authorization:
                "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
            },
            data: {
                dashboard_notes_id: notesId
            },
          });
      const deleteNotesData = response.data.data;
     // console.log("deleteNotesData", deleteNotesData)
      dispatch(deleteNotesSuccess(deleteNotesData));
    } catch (error) {
      console.log("Redux error - ", error.response.data.message);
      const errorMsg = error.response.data.message;
      dispatch(deleteNotesFailure(errorMsg));
    }
  };
};
